import { EventStructure } from "../types";

function ageAndGender(event: EventStructure) {
  const age = new URL(window.location.href).searchParams.get("age");
  const gender = new URL(window.location.href).searchParams.get("gender");
  // console.info({ age, gender });

  if (age) {
    event.demographic.age = age;
  }

  if (gender) {
    event.demographic.gender = gender;
  }

  return event;
}

function city(event: EventStructure) {
  const city = new URL(window.location.href).searchParams.get("city");
  const country = new URL(window.location.href).searchParams.get("country");
  // console.info({ city, country });

  if (city) {
    event.persona.attributes.location = {
      city,
      country: country || "",
      geolocationEnabled: false,
    };
  }
  return event;
}

export function demoSpecificOverrides(event: EventStructure) {
  ageAndGender(event);
  city(event);
}
